import { useEffect, useState } from "react";
import { apiGet, fmt } from "@/lib/api";
import { fmtDateTime } from "@/lib/terminalUtils";

export const JournalPanel = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiGet("/journal").then((r) => setData(r.data)).catch(() => setData({ trades: [], stats: null }));
  }, []);

  if (!data) return <p className="font-mono text-xs text-mute-dim">memuat jurnal...</p>;

  const { trades, stats } = data;

  return (
    <div data-testid="journal-panel">
      {stats && (
        <div className="mb-5 flex flex-wrap gap-2 font-mono text-xs">
          <span className="border border-white/15 px-3 py-1.5 text-mute">trade: <b className="text-white">{stats.total}</b></span>
          <span className="border border-white/15 px-3 py-1.5 text-mute">win rate: <b className="text-buy">{stats.win_rate}%</b></span>
          <span className="border border-white/15 px-3 py-1.5 text-mute">profit factor: <b className="text-white">{stats.profit_factor}</b></span>
          <span className="border border-white/15 px-3 py-1.5 text-mute">total PNL: <b className={stats.total_pnl >= 0 ? "text-buy" : "text-sell"}>{stats.total_pnl >= 0 ? "+" : ""}{fmt(stats.total_pnl)} USD</b></span>
        </div>
      )}
      {trades.length === 0 ? (
        <div className="border border-white/10 bg-ink-surface p-8 text-center">
          <p className="font-mono text-xs text-mute-dim">
            &gt; jurnal kosong — posisi paper trade yang ditutup akan tercatat di sini secara otomatis
            <span className="blink-cursor ml-1 text-buy">▌</span>
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto border border-white/10">
          <table className="w-full min-w-[640px] text-left" data-testid="journal-table">
            <thead>
              <tr className="border-b border-white/10 bg-ink-surface font-mono text-[9px] uppercase tracking-widest text-mute-dim">
                <th className="px-4 py-3">Waktu</th><th className="px-4 py-3">Simbol</th><th className="px-4 py-3">Arah</th>
                <th className="px-4 py-3">Entry</th><th className="px-4 py-3">Exit</th><th className="px-4 py-3">Skor</th>
                <th className="px-4 py-3">Alasan Tutup</th><th className="px-4 py-3 text-right">PNL</th>
              </tr>
            </thead>
            <tbody>
              {trades.map((t) => (
                <tr key={t.id} className="border-b border-white/5 font-mono text-xs hover:bg-white/[0.03]">
                  <td className="px-4 py-2.5 text-mute-dim">{t.closed_at ? fmtDateTime(t.closed_at) : "—"}</td>
                  <td className="px-4 py-2.5 font-bold text-white">{t.symbol}</td>
                  <td className={`px-4 py-2.5 font-bold ${t.direction === "BUY" ? "text-buy" : "text-sell"}`}>{t.direction}</td>
                  <td className="px-4 py-2.5 text-mute">{t.entry}</td>
                  <td className="px-4 py-2.5 text-mute">{t.exit}</td>
                  <td className="px-4 py-2.5 text-mute">{t.score}</td>
                  <td className="px-4 py-2.5 text-mute">{t.close_reason}</td>
                  <td className={`px-4 py-2.5 text-right font-bold ${t.pnl >= 0 ? "text-buy" : "text-sell"}`}>
                    {t.pnl >= 0 ? "+" : ""}{fmt(t.pnl)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
